import { BASE_URL } from '../constants/url-constants';
import { SUMMER_JOBS_PATHS, type SummerJobsLocale } from '../routing/summer-jobs-resource-paths';

export const SUMMER_JOBS_OG_IMAGE =
  'https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=1200&q=80&auto=format&fit=crop';

/** ISO used for article:published_time and JSON-LD datePublished */
export const SUMMER_JOBS_DATE_PUBLISHED = '2026-03-25T00:00:00Z';

/** Three-segment SERP titles (≤60 chars) shared by +title.ts and +Head.clear.tsx */
export const SUMMER_JOBS_PAGE_TITLES: Record<SummerJobsLocale, string> = {
  en: 'Summer jobs Finland | Live seasonal listings | JobCrawls',
  fi: 'Kesätyöt Suomi | Kausi-ilmoitukset yhteen haussa | JobCrawls',
  sv: 'Sommarjobb Finland | Säsongsjobb samlade | JobCrawls',
};

export function summerJobsOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'JobCrawls',
    url: BASE_URL,
    logo: {
      '@type': 'ImageObject',
      url: `${BASE_URL}/logo_jobcrawls_horizontal.png`,
    },
    sameAs: [
      'https://www.linkedin.com/company/jobcrawls',
      'https://twitter.com/jobcrawls',
    ],
  };
}

export function summerJobsWebPageSchema(args: {
  locale: SummerJobsLocale;
  title: string;
  description: string;
  url: string;
  ogImage: string;
  /** Localized primary topic label for structured data */
  aboutName: string;
}) {
  const inLanguage = args.locale === 'fi' ? 'fi-FI' : args.locale === 'sv' ? 'sv-SE' : 'en-US';
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: args.title,
    description: args.description,
    url: args.url,
    inLanguage,
    isPartOf: {
      '@type': 'WebSite',
      name: 'JobCrawls',
      url: BASE_URL,
    },
    primaryImageOfPage: {
      '@type': 'ImageObject',
      url: args.ogImage,
    },
    about: {
      '@type': 'Thing',
      name: args.aboutName,
      description: args.description,
    },
  };
}

/** og:locale:alternate pairs for a given primary locale */
export function summerJobsOgLocaleAlternates(primary: SummerJobsLocale): { locale: string; url: string }[] {
  const map: Record<SummerJobsLocale, { locale: string; url: string }[]> = {
    en: [
      { locale: 'fi_FI', url: `${BASE_URL}${SUMMER_JOBS_PATHS.fi}` },
      { locale: 'sv_SE', url: `${BASE_URL}${SUMMER_JOBS_PATHS.sv}` },
    ],
    fi: [
      { locale: 'en_US', url: `${BASE_URL}${SUMMER_JOBS_PATHS.en}` },
      { locale: 'sv_SE', url: `${BASE_URL}${SUMMER_JOBS_PATHS.sv}` },
    ],
    sv: [
      { locale: 'en_US', url: `${BASE_URL}${SUMMER_JOBS_PATHS.en}` },
      { locale: 'fi_FI', url: `${BASE_URL}${SUMMER_JOBS_PATHS.fi}` },
    ],
  };
  return map[primary];
}
